'use client';

import posthog from 'posthog-js';

// PostHog is a statistics tool, so under Cookiebot it must not run — or set a
// single cookie — until the visitor accepts that category. It arrives as an npm
// package rather than an inline snippet, so there is no script tag to mark with
// `type="text/plain"`; the equivalent is simply not calling `init` until
// consent lands. Nothing else in the app imports `posthog-js` directly except
// `analytics.ts`, which no-ops while this stays uninitialized.

const env =
  process.env.NEXT_PUBLIC_APP_ENV ??
  (process.env.NODE_ENV === 'production' ? 'production' : 'staging');

// TODO: remove hardcoded fallbacks once AWS is confirmed to inject these env vars in production
const POSTHOG_KEY =
  process.env.NEXT_PUBLIC_POSTHOG_KEY ??
  'phc_uPw22rMrRLMhkVutqRu77CHATk6QCShFqgvww4yVzEx4';
const POSTHOG_HOST =
  process.env.NEXT_PUBLIC_POSTHOG_HOST ?? 'https://us.i.posthog.com';

let initialized = false;

export function isPostHogReady(): boolean {
  return initialized;
}

/** Idempotent — safe to call on every consent event. */
export function initPostHog(): void {
  if (initialized || typeof window === 'undefined') return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
  });
  // Attach environment to every event as a super property
  posthog.register({ environment: env });
  initialized = true;
}

/**
 * Stops capturing and drops the identity. Cookiebot reloads the page after a
 * consent change, so this mainly covers the gap before that reload.
 */
export function stopPostHog(): void {
  if (!initialized) return;
  posthog.opt_out_capturing();
  posthog.reset(true);
}

export { posthog };
